export const dashboards = [
  {
    id: 1,
    name: "Reporting",
    reports: [
      { id: 1, href: "balance-sheet", name: "Balance Sheet" },
      { id: 2, href: "cash-flow", name: "Cash Flow" },
      { id: 3, href: "profit-loss", name: "Profit & Loss" },
    ],
  },
  {
    id: 2,
    name: "Finance",
    reports: [
      { id: 1, href: "financial-overview", name: "Financial Overview" },
      { id: 2, href: "revenue-analysis", name: "Revenue Analysis" },
      { id: 3, href: "expense-management", name: "Expense Management" },
      { id: 4, href: "partners-capital", name: "Partners Capital" },
      { id: 5, href: "investment-schedule", name: "Investment Schedule" },
      { id: 6, href: "profitability-metrics", name: "Profitability Metrics" },
      { id: 7, href: "cash-flow-analysis", name: "Cash Flow Analysis" },
      {
        id: 8,
        href: "budgeting-and-forecasting",
        name: "Budgeting and Forecasting",
      },
      { id: 9, href: "financial-ratios", name: "Financial Ratios" },
      {
        id: 10,
        href: "investment-portfolio-analysis",
        name: "Investment Portfolio Analysis",
      },
      {
        id: 11,
        href: "financial-trends-and-kpis",
        name: "Financial Trends and KPIs",
      },
      { id: 12, href: "risk-management", name: "Risk Management" },
      {
        id: 13,
        href: "compliance-and-regulatory-reporting",
        name: "Compliance and Regulatory Reporting",
      },
      { id: 14, href: "tax-management", name: "Tax Management" },
      {
        id: 15,
        href: "currency-exchange-and-foreign-exchange-rates",
        name: "Currency Exchange and Foreign Exchange Rates",
      },
      {
        id: 16,
        href: "vendor-and-supplier-management",
        name: "Vendor and Supplier Management",
      },
      {
        id: 17,
        href: "financial-dashboard-customization",
        name: "Financial Dashboard Customization",
      },
    ],
  },
  {
    id: 3,
    name: "Admin",
    reports: [
      { id: 1, href: "user-management", name: "User Management" },
      { id: 2, href: "content-management", name: "Content Management" },
      {
        id: 3,
        href: "analytics-and-reporting",
        name: "Analytics and Reporting",
      },
      {
        id: 4,
        href: "system-health-and-monitoring",
        name: "System Health and Monitoring",
      },
      {
        id: 5,
        href: "customer-support-and-tickets",
        name: "Customer Support and Tickets",
      },
      { id: 6, href: "inventory-management", name: "Inventory Management" },
      { id: 7, href: "task-management", name: "Task Management" },
      { id: 8, href: "financial-management", name: "Financial Management" },
      {
        id: 9,
        href: "security-and-access-control",
        name: "Security and Access Control",
      },
      {
        id: 10,
        href: "communication-and-notifications",
        name: "Communication and Notifications",
      },
      {
        id: 11,
        href: "settings-and-configuration",
        name: "Settings and Configuration",
      },
      {
        id: 12,
        href: "audit-trail-and-history",
        name: "Audit Trail and History",
      },
      { id: 13, href: "data-visualization", name: "Data Visualization" },
      { id: 14, href: "mobile-responsiveness", name: "Mobile Responsiveness" },
      {
        id: 15,
        href: "customization-and-personalization",
        name: "Customization and Personalization",
      },
    ],
  },
  {
    id: 4,
    name: "HR",
    reports: [
      { id: 1, href: "employee-performance", name: "Employee Performance" },
      { id: 2, href: "recruitment", name: "Recruitment" },
      { id: 3, href: "employee-engagement", name: "Employee Engagement" },
      {
        id: 4,
        href: "training-and-development",
        name: "Training and Development",
      },
      { id: 5, href: "turnover-and-retention", name: "Turnover and Retention" },
      {
        id: 6,
        href: "diversity-and-inclusion",
        name: "Diversity and Inclusion",
      },
      {
        id: 7,
        href: "compensation-and-benefits",
        name: "Compensation and Benefits",
      },
      {
        id: 8,
        href: "attendance-and-leave-management",
        name: "Attendance and Leave Management",
      },
      { id: 9, href: "health-and-wellness", name: "Health and Wellness" },
      { id: 10, href: "hr-analytics", name: "HR Analytics" },
    ],
  },
  {
    id: 5,
    name: "MIS",
    reports: [
      { id: 1, href: "sales-performance", name: "Sales Performance" },
      { id: 2, href: "financial-summary", name: "Financial Summary" },
      { id: 3, href: "inventory-status", name: "Inventory Status" },
      { id: 4, href: "crm", name: "Customer Relationship Management (CRM)" },
      { id: 5, href: "procurement", name: "Procurement and Purchase" },
      { id: 6, href: "employee-performance", name: "Employee Performance" },
      { id: 7, href: "project-management", name: "Project Management" },
      { id: 8, href: "quality-assurance", name: "Quality Assurance" },
      { id: 9, href: "scm", name: "Supply Chain Management (SCM)" },
      {
        id: 10,
        href: "marketing-effectiveness",
        name: "Marketing Effectiveness",
      },
      {
        id: 11,
        href: "operational-efficiency",
        name: "Operational Efficiency",
      },
      {
        id: 12,
        href: "compliance-risk-management",
        name: "Compliance and Risk Management",
      },
      {
        id: 13,
        href: "customer-satisfaction",
        name: "Customer Satisfaction and Feedback",
      },
      { id: 14, href: "executive-dashboard", name: "Executive Dashboard" },
    ],
  },
  {
    id: 6,
    name: "Marketing",
    reports: [
      { id: 1, href: "website-traffic", name: "Website Trafficking" },
      { id: 2, href: "email-marketing", name: "Email Marketing" },
      { id: 3, href: "social-media", name: "Social Media" },
      { id: 4, href: "content-marketing", name: "Content Marketing" },
      { id: 5, href: "paid-advertising", name: "Paid Advertising" },
      { id: 6, href: "customer-acquisition", name: "Customer Acquisition" },
      { id: 7, href: "marketing-funnel", name: "Marketing Funnel" },
      { id: 8, href: "brand-monitoring", name: "Brand Monitoring" },
      { id: 9, href: "marketing-roi", name: "Marketing ROI" },
    ],
  },
  {
    id: 7,
    name: "KPI",
    reports: [
      { id: 1, href: "sales", name: "Sales" },
      { id: 2, href: "marketing", name: "Marketing" },
      { id: 3, href: "financial", name: "Financial" },
      { id: 4, href: "customer-service", name: "Customer Service" },
      { id: 5, href: "human-resources", name: "Human Resources" },
      { id: 6, href: "project-management", name: "Project Management" },
      { id: 7, href: "supply-chain", name: "Supply Chain" },
      { id: 8, href: "quality-assurance", name: "Quality Assurance" },
      { id: 9, href: "healthcare", name: "Healthcare" },
    ],
  },
  {
    id: 8,
    name: "SAAS",
    reports: [
      { id: 1, href: "mrr", name: "Monthly Recurring Revenue (MRR)" },
      { id: 2, href: "arr", name: "Annual Recurring Revenue (ARR)" },
      { id: 3, href: "churn-rate", name: "Churn Rate" },
      { id: 4, href: "cltv", name: "Customer Lifetime Value (CLTV)" },
      { id: 5, href: "cac", name: "Customer Acquisition Cost (CAC)" },
      { id: 6, href: "cac-payback", name: "CAC Payback Period" },
      { id: 7, href: "expansion-revenue", name: "Expansion Revenue" },
      { id: 8, href: "nps", name: "Net Promoter Score (NPS)" },
      { id: 9, href: "customer-retention", name: "Customer Retention Rate" },
      { id: 10, href: "active-users", name: "Active Users/Customers" },
      {
        id: 11,
        href: "customer-engagement",
        name: "Customer Engagement Metrics",
      },
      { id: 12, href: "csat", name: "Customer Satisfaction (CSAT)" },
      { id: 13, href: "product-adoption", name: "Product Adoption Rate" },
      { id: 14, href: "customer-support", name: "Customer Support Metrics" },
      { id: 15, href: "user-retention", name: "User Retention by Cohort" },
      { id: 16, href: "gross-margin", name: "Gross Margin" },
      { id: 17, href: "arpa", name: "Average Revenue per Account (ARPA)" },
      { id: 18, href: "free-trial", name: "Free Trial Conversion Rate" },
    ],
  },
  {
    id: 9,
    name: "Travel and Tourism",
    reports: [
      { id: 1, href: "occupancy-rate", name: "Occupancy Rate" },
      { id: 2, href: "average-daily-rate", name: "Average Daily Rate (ADR)" },
      {
        id: 3,
        href: "revenue-per-available-room",
        name: "Revenue per Available Room (RevPAR)",
      },
      { id: 4, href: "room-nights-sold", name: "Room Nights Sold" },
      {
        id: 5,
        href: "average-length-of-stay",
        name: "Average Length of Stay (ALOS)",
      },
      {
        id: 6,
        href: "customer-satisfaction-score",
        name: "Customer Satisfaction Score (CSAT)",
      },
      { id: 7, href: "net-promoter-score", name: "Net Promoter Score (NPS)" },
      {
        id: 8,
        href: "revenue-by-source-market",
        name: "Revenue by Source Market",
      },
      {
        id: 9,
        href: "average-spend-per-visitor",
        name: "Average Spend per Visitor",
      },
      { id: 10, href: "visitor-arrivals", name: "Visitor Arrivals" },
      { id: 11, href: "visitor-demographics", name: "Visitor Demographics" },
      {
        id: 12,
        href: "attraction-or-destination-attendance",
        name: "Attraction or Destination Attendance",
      },
      {
        id: 13,
        href: "customer-loyalty",
        name: "Customer Loyalty and Repeat Visitation",
      },
      { id: 14, href: "tourism-revenue", name: "Tourism Revenue" },
      {
        id: 15,
        href: "booking-conversion-rate",
        name: "Booking Conversion Rate",
      },
      { id: 16, href: "tourism-expenditure", name: "Tourism Expenditure" },
      { id: 17, href: "tourism-employment", name: "Tourism Employment" },
      {
        id: 18,
        href: "social-media-engagement",
        name: "Social Media Engagement",
      },
      {
        id: 19,
        href: "tourism-infrastructure",
        name: "Tourism Infrastructure and Development",
      },
    ],
  },
  {
    id: 10,
    name: "Hospitality",
    reports: [
      { id: 1, href: "occupancy-rate", name: "Occupancy Rate" },
      { id: 2, href: "average-daily-rate", name: "Average Daily Rate (ADR)" },
      {
        id: 3,
        href: "revenue-per-available-room",
        name: "Revenue per Available Room (RevPAR)",
      },
      { id: 4, href: "average-check-size", name: "Average Check Size" },
      { id: 5, href: "table-turnover-rate", name: "Table Turnover Rate" },
      { id: 6, href: "room-revenue", name: "Room Revenue" },
      {
        id: 7,
        href: "food-and-beverage-revenue",
        name: "Food and Beverage Revenue",
      },
      {
        id: 8,
        href: "customer-satisfaction-score",
        name: "Customer Satisfaction Score (CSAT)",
      },
      { id: 9, href: "net-promoter-score", name: "Net Promoter Score (NPS)" },
      { id: 10, href: "revenue-by-department", name: "Revenue by Department" },
      { id: 11, href: "labor-cost-percentage", name: "Labor Cost Percentage" },
      {
        id: 12,
        href: "customer-retention-rate",
        name: "Customer Retention Rate",
      },
      {
        id: 13,
        href: "average-length-of-stay",
        name: "Average Length of Stay (ALOS)",
      },
      {
        id: 14,
        href: "return-on-investment",
        name: "Return on Investment (ROI)",
      },
      {
        id: 15,
        href: "maintenance-and-housekeeping-efficiency",
        name: "Maintenance and Housekeeping Efficiency",
      },
      { id: 16, href: "cost-of-goods-sold", name: "Cost of Goods Sold (COGS)" },
      {
        id: 17,
        href: "employee-turnover-rate",
        name: "Employee Turnover Rate",
      },
      {
        id: 18,
        href: "event-and-banquet-sales",
        name: "Event and Banquet Sales",
      },
      {
        id: 19,
        href: "online-reputation-score",
        name: "Online Reputation Score",
      },
      {
        id: 20,
        href: "sustainability-metrics",
        name: "Sustainability Metrics",
      },
    ],
  },
  {
    id: 11,
    name: "BPO",
    reports: [
      {
        id: 1,
        href: "service-level-agreement",
        name: "Service Level Agreement (SLA)",
      },
      {
        id: 2,
        href: "average-handling-time",
        name: "Average Handling Time (AHT)",
      },
      {
        id: 3,
        href: "first-call-resolution",
        name: "First Call Resolution (FCR) Rate",
      },
      {
        id: 4,
        href: "customer-satisfaction-score",
        name: "Customer Satisfaction Score (CSAT)",
      },
      { id: 5, href: "net-promoter-score", name: "Net Promoter Score (NPS)" },
      { id: 6, href: "quality-assurance", name: "Quality Assurance (QA)" },
      { id: 7, href: "agent-utilization-rate", name: "Agent Utilization Rate" },
      { id: 8, href: "absenteeism-rate", name: "Absenteeism Rate" },
      { id: 9, href: "adherence-to-schedule", name: "Adherence to Schedule" },
      {
        id: 10,
        href: "employee-satisfaction",
        name: "Employee Satisfaction (ESAT)",
      },
      {
        id: 11,
        href: "training-effectiveness",
        name: "Training Effectiveness",
      },
      {
        id: 12,
        href: "revenue-per-fte",
        name: "Revenue per Full-Time Equivalent (FTE)",
      },
      { id: 13, href: "cost-per-contact", name: "Cost per Contact" },
      {
        id: 14,
        href: "customer-retention-rate",
        name: "Customer Retention Rate",
      },
      { id: 15, href: "error-rate", name: "Error Rate" },
      {
        id: 16,
        href: "service-level-achievement",
        name: "Service Level Achievement",
      },
      {
        id: 17,
        href: "average-speed-of-answer",
        name: "Average Speed of Answer (ASA)",
      },
      {
        id: 18,
        href: "customer-effort-score",
        name: "Customer Effort Score (CES)",
      },
      {
        id: 19,
        href: "customer-complaint-resolution-time",
        name: "Customer Complaint Resolution Time",
      },
      {
        id: 20,
        href: "process-improvement-initiatives",
        name: "Process Improvement Initiatives",
      },
    ],
  },
  {
    id: 12,
    name: "KPO",
    reports: [
      { id: 1, href: "project-overview", name: "Project Overview" },
      { id: 2, href: "resource-allocation", name: "Resource Allocation" },
      { id: 3, href: "task-progress", name: "Task Progress and Completion" },
      {
        id: 4,
        href: "quality-assurance",
        name: "Quality Assurance (QA) Metrics",
      },
      {
        id: 5,
        href: "client-satisfaction",
        name: "Client Satisfaction Score (CSAT)",
      },
      { id: 6, href: "knowledge-management", name: "Knowledge Management" },
      { id: 7, href: "data-analysis", name: "Data Analysis and Insights" },
      { id: 8, href: "time-tracking", name: "Time Tracking and Billing" },
      {
        id: 9,
        href: "client-relationship",
        name: "Client Relationship Management (CRM)",
      },
      { id: 10, href: "risk-management", name: "Risk Management" },
      { id: 11, href: "financial-performance", name: "Financial Performance" },
      {
        id: 12,
        href: "team-performance",
        name: "Team Performance and Productivity",
      },
      { id: 13, href: "knowledge-domain", name: "Knowledge Domain Expertise" },
      {
        id: 14,
        href: "compliance-regulatory",
        name: "Compliance and Regulatory Reporting",
      },
      {
        id: 15,
        href: "executive-summary",
        name: "Executive Summary and Insights",
      },
    ],
  },
];

export const appsName = [
  {
    category: "Accounting",
    apps: [
      { id: 1, name: "Account - Billing" },
      { id: 2, name: "Account - Notifications" },
      { id: 3, name: "Account - Profile" },
      { id: 4, name: "Account - Security" },
    ],
  },
  {
    category: "Authentication",
    apps: [
      { id: 5, name: "Auth - Login" },
      { id: 6, name: "Auth - Login (Social)" },
      { id: 7, name: "Auth - Multi Tenant" },
      { id: 8, name: "Auth - Password" },
      { id: 9, name: "Auth - Password (Social)" },
      { id: 10, name: "Auth - Register" },
      { id: 11, name: "Auth - Register (Social)" },
      { id: 12, name: "Invoice" },
      { id: 13, name: " Article" },
      { id: 14, name: "Knowledgebase - Category" },
      { id: 15, name: "Knowledgebase - Home 1" },
      { id: 16, name: "Knowledgebase - Home 2" },
      { id: 17, name: "Pricing" },
      { id: 18, name: "Wizard" },
    ],
  },
];

export const arrangedApps = [
  {
    category: "Accounting",
    apps: [
      { id: 1, name: "Billing" },
      { id: 2, name: "Notifications" },
      { id: 3, name: "Profile" },
      { id: 4, name: "Security" },
    ],
  },
  {
    category: "Bookkeeping",
    apps: [
      { id: 1, name: "Billing" },
      { id: 2, name: "Notifications" },
      { id: 3, name: "Profile" },
      { id: 4, name: "Security" },
    ],
  },
  {
    category: "Payroll",
    apps: [
      { id: 5, name: " Login" },
      { id: 6, name: " Login (Social)" },
      { id: 7, name: " Multi Tenant" },
      { id: 8, name: " Password" },
      { id: 9, name: " Password (Social)" },
      { id: 10, name: " Register" },
      { id: 11, name: " Register (Social)" },
    ],
  },
  {
    category: "Tax Planning",
    apps: [{ id: 12, name: "Invoice" }],
  },
  {
    category: "Financial Reporting",
    apps: [
      { id: 13, name: " Article" },
      { id: 14, name: " Category" },
      { id: 15, name: " Home 1" },
      { id: 16, name: " Home 2" },
    ],
  },
  {
    category: "Audit",
    apps: [{ id: 17, name: "Pricing" }],
  },
  {
    category: "Due diligence",
    apps: [{ id: 17, name: "Pricing" }],
  },
  {
    category: " Compliances",
    apps: [{ id: 17, name: "Pricing" }],
  },
  // {
  //   category: "Wizard",
  //   apps: [{ id: 18, name: "Wizard" }],
  // },
];

export const appsPages = [
  {
    category: "Account",
    apps: [
      { id: 1, name: "Profile" },
      { id: 2, name: "Billing" },
      { id: 3, name: "Security" },
      { id: 4, name: "Notifications" },
    ],
  },
  // {
  //   category: "Authentication",
  //   apps: [

  //     { id: 2, name: "Social" },
  //   ],

  // },

  {
    category: "Pricing",
    slug: "pricing",
  },
  // {
  //   category: "Invoice",
  //   slug: "invoice",
  // },

  // {
  //   category: "Wizard",
  //   apps: [{ id: 18, name: "Wizard" }],
  // },
];

export const uploadDocs = [
  {
    category: "Invoices",
    id: Date.now(),
    subCategory: [
      {
        name: "Sales",
        listName: ["Goods", "Services", "Others"],
      },
      {
        name: "Purchase",
        listName: ["Goods", "Services", "Assets"],
      },
      {
        name: "Credit Note",
        listName: ["Credit note"],
      },
      {
        name: "Debit Notes",
        listName: ["Debit Note"],
      },
      {
        name: "Expenses",
        listName: ["Operating", "Financing", "Investment"],
      },
      {
        name: "Capital",
        listName: ["Capital"],
      },
    ],
  },
  {
    category: "Upload Bank Statement",
    id: Date.now(),
    subCategory: [
      {
        name: "Saving Account",
        listName: ["Bank Statement"],
      },
      {
        name: "Current Account",
        listName: ["Bank Statement"],
      },
      {
        name: "Currency Account",
        listName: ["Bank Statement"],
      },
    ],
  },
  {
    category: "Other Docs",
    id: Date.now(),
    subCategory: [
      {
        name: "Docs",
        listName: ["Docs"],
      },
    ],
  },

  {
    category: "Reports",
    id: Date.now(),
    subCategory: [
      {
        name: "Finance",
        listName: ["Balance", "Profit Loss", "cash flow"],
      },
      {
        name: "Admin",
        listName: [
          "User Management",
          "Content Management",
          "Analytics and Reporting",
          "System Health and Monitoring",
          // "Customer Support and Tickets",
          // "Inventory Management",
          // "Task Management",
          // "Financial Management",
          // "Security and Access Control",
          // "Communication and Notifications",
          // "Settings and Configuration",
          // "Audit Trail and History",
          // "Data Visualization",
          // "Mobile Responsiveness",
          // "Customization and Personalization",
        ],
      },
      {
        name: "HR",
        listName: [
          "Employee Performance Dashboard",
          "Recruitment Dashboard",
          "Employee Engagement Dashboard",
          // "Training and Development Dashboard",
          // "Turnover and Retention Dashboard",
          // "Diversity and Inclusion Dashboard",
          // "Compensation and Benefits Dashboard",
          // "Attendance and Leave Management Dashboard",
          // "Health and Wellness Dashboard",
          // "HR Analytics Dashboard"
        ],
      },
      {
        name: "MIS",
        listName: ["Docs"],
      },
      {
        name: "Marketing",
        listName: ["Docs"],
      },
    ],
  },
];

export const customisationPages = [
  { id: 1, name: "Reports" },
  {
    id: 2,
    name: "Automation",
  },
];

export const accoutingPages = [
  { id: 1, name: "Journal Posting", href:"journalposting" },
  { id: 2, name: "Reports", href:"report" },
  { id: 3, name: "Bank Statement", href:"bankstatement" },
  { id: 4, name: "Ledger Setup", href:"ledgersetup" },
];
export const caPortal = [
  { id: 1, name: "Audit report", href:"auditreport" },
  { id: 2, name: "Audit Approvals", href:"auditapproval" },
  { id: 3, name: "Audit Requests", href:"auditrequestt" },
  
];
export const billingDetails = [
  {
    id: 1,
    name: "Current monthly bill",
    desc: "$20.00",
    plan: "Switch to yearly billing",
    borderColor: "primary",
    textColor: "primary",
  },
  {
    id: 2,
    name: "Next payment due",
    desc: "July 15",
    plan: "View payment history",
    borderColor: "danger",
    textColor: "danger",
  },
  {
    id: 3,
    name: "Current plan",
    desc: "Freelancer",
    plan: "Upgrade plan",
    borderColor: "success",
    textColor: "success",
  },
];
// { id: 1, href: "#", name: "Entry Posting" },
// { id: 2, href: "#", name: "Reports" },
// { id: 3, herf: "#", name: "Bank Statement" },
// { id: 4, href: "ledger-creation", name: "Ledger Creation" },
// export const sidebar = [
//   {
//     label: "Dashboard",
//     items: [
//       {
//         slug: "reporting",
//         name: "Reporting",
//         items: [
//           { id: 1, href: "balance-sheet", name: "Balance Sheet" },
//           { id: 2, href: "cash-flow", name: "Cash Flow" },
//           { id: 3, href: "profit-loss", name: "Profit & Loss" },
//         ],
//       },
//       {
//         slug: "finance",
//         name: "Finance",
//         items: [
//           { id: 1, href: "financial-overview", name: "Financial Overview" },
//           { id: 2, href: "revenue-analysis", name: "Revenue Analysis" },
//           { id: 3, href: "expense-management", name: "Expense Management" },
//           { id: 4, href: "partners-capital", name: "Partners Capital" },
//           { id: 5, href: "investment-schedule", name: "Investment Schedule" },
//           {
//             id: 6,
//             href: "profitability-metrics",
//             name: "Profitability Metrics",
//           },
//           { id: 7, href: "cash-flow-analysis", name: "Cash Flow Analysis" },
//           {
//             id: 8,
//             href: "budgeting-and-forecasting",
//             name: "Budgeting and Forecasting",
//           },
//           { id: 9, href: "financial-ratios", name: "Financial Ratios" },
//           {
//             id: 10,
//             href: "investment-portfolio-analysis",
//             name: "Investment Portfolio Analysis",
//           },
//           {
//             id: 11,
//             href: "financial-trends-and-kpis",
//             name: "Financial Trends and KPIs",
//           },
//           { id: 12, href: "risk-management", name: "Risk Management" },
//           {
//             id: 13,
//             href: "compliance-and-regulatory-reporting",
//             name: "Compliance and Regulatory Reporting",
//           },
//           { id: 14, href: "tax-management", name: "Tax Management" },
//           {
//             id: 15,
//             href: "currency-exchange-and-foreign-exchange-rates",
//             name: "Currency Exchange and Foreign Exchange Rates",
//           },
//           {
//             id: 16,
//             href: "vendor-and-supplier-management",
//             name: "Vendor and Supplier Management",
//           },
//           {
//             id: 17,
//             href: "financial-dashboard-customization",
//             name: "Financial Dashboard Customization",
//           },
//         ],
//       },
//       {
//         slug: "admin",
//         name: "Admin",
//         reports: [
//           { id: 1, href: "user-management", name: "User Management" },
//           { id: 2, href: "content-management", name: "Content Management" },
//           {
//             id: 3,
//             href: "analytics-and-reporting",
//             name: "Analytics and Reporting",
//           },
//           {
//             id: 4,
//             href: "system-health-and-monitoring",
//             name: "System Health and Monitoring",
//           },
//           {
//             id: 5,
//             href: "customer-support-and-tickets",
//             name: "Customer Support and Tickets",
//           },
//           { id: 6, href: "inventory-management", name: "Inventory Management" },
//           { id: 7, href: "task-management", name: "Task Management" },
//           { id: 8, href: "financial-management", name: "Financial Management" },
//           {
//             id: 9,
//             href: "security-and-access-control",
//             name: "Security and Access Control",
//           },
//           {
//             id: 10,
//             href: "communication-and-notifications",
//             name: "Communication and Notifications",
//           },
//           {
//             id: 11,
//             href: "settings-and-configuration",
//             name: "Settings and Configuration",
//           },
//           {
//             id: 12,
//             href: "audit-trail-and-history",
//             name: "Audit Trail and History",
//           },
//           { id: 13, href: "data-visualization", name: "Data Visualization" },
//           {
//             id: 14,
//             href: "mobile-responsiveness",
//             name: "Mobile Responsiveness",
//           },
//           {
//             id: 15,
//             href: "customization-and-personalization",
//             name: "Customization and Personalization",
//           },
//         ],
//       },
//       {
//         slug: "hr",
//         name: "HR",
//         items: [
//           { id: 1, href: "employee-performance", name: "Employee Performance" },
//           { id: 2, href: "recruitment", name: "Recruitment" },
//           { id: 3, href: "employee-engagement", name: "Employee Engagement" },
//           {
//             id: 4,
//             href: "training-and-development",
//             name: "Training and Development",
//           },
//           {
//             id: 5,
//             href: "turnover-and-retention",
//             name: "Turnover and Retention",
//           },
//           {
//             id: 6,
//             href: "diversity-and-inclusion",
//             name: "Diversity and Inclusion",
//           },
//           {
//             id: 7,
//             href: "compensation-and-benefits",
//             name: "Compensation and Benefits",
//           },
//           {
//             id: 8,
//             href: "attendance-and-leave-management",
//             name: "Attendance and Leave Management",
//           },
//           { id: 9, href: "health-and-wellness", name: "Health and Wellness" },
//           { id: 10, href: "hr-analytics", name: "HR Analytics" },
//         ],
//       },
//       {
//         slug: "mis",
//         name: "MIS",
//         items: [
//           { id: 1, href: "sales-performance", name: "Sales Performance" },
//           { id: 2, href: "financial-summary", name: "Financial Summary" },
//           { id: 3, href: "inventory-status", name: "Inventory Status" },
//           {
//             id: 4,
//             href: "crm",
//             name: "Customer Relationship Management (CRM)",
//           },
//           { id: 5, href: "procurement", name: "Procurement and Purchase" },
//           { id: 6, href: "employee-performance", name: "Employee Performance" },
//           { id: 7, href: "project-management", name: "Project Management" },
//           { id: 8, href: "quality-assurance", name: "Quality Assurance" },
//           { id: 9, href: "scm", name: "Supply Chain Management (SCM)" },
//           {
//             id: 10,
//             href: "marketing-effectiveness",
//             name: "Marketing Effectiveness",
//           },
//           {
//             id: 11,
//             href: "operational-efficiency",
//             name: "Operational Efficiency",
//           },
//           {
//             id: 12,
//             href: "compliance-risk-management",
//             name: "Compliance and Risk Management",
//           },
//           {
//             id: 13,
//             href: "customer-satisfaction",
//             name: "Customer Satisfaction and Feedback",
//           },
//           { id: 14, href: "executive-dashboard", name: "Executive Dashboard" },
//         ],
//       },
//       {
//         slug: "marketing",
//         name: "Marketing",
//         items: [
//           { id: 1, href: "website-traffic", name: "Website Trafficking" },
//           { id: 2, href: "email-marketing", name: "Email Marketing" },
//           { id: 3, href: "social-media", name: "Social Media" },
//           { id: 4, href: "content-marketing", name: "Content Marketing" },
//           { id: 5, href: "paid-advertising", name: "Paid Advertising" },
//           { id: 6, href: "customer-acquisition", name: "Customer Acquisition" },
//           { id: 7, href: "marketing-funnel", name: "Marketing Funnel" },
//           { id: 8, href: "brand-monitoring", name: "Brand Monitoring" },
//           { id: 9, href: "marketing-roi", name: "Marketing ROI" },
//         ],
//       },
//       {
//         slug: "kpi",
//         name: "KPI",
//         items: [
//           { id: 1, href: "sales", name: "Sales" },
//           { id: 2, href: "marketing", name: "Marketing" },
//           { id: 3, href: "financial", name: "Financial" },
//           { id: 4, href: "customer-service", name: "Customer Service" },
//           { id: 5, href: "human-resources", name: "Human Resources" },
//           { id: 6, href: "project-management", name: "Project Management" },
//           { id: 7, href: "supply-chain", name: "Supply Chain" },
//           { id: 8, href: "quality-assurance", name: "Quality Assurance" },
//           { id: 9, href: "healthcare", name: "Healthcare" },
//         ],
//       },
//       {
//         slug: "saas",
//         name: "SAAS",
//         items: [
//           { id: 1, href: "mrr", name: "Monthly Recurring Revenue (MRR)" },
//           { id: 2, href: "arr", name: "Annual Recurring Revenue (ARR)" },
//           { id: 3, href: "churn-rate", name: "Churn Rate" },
//           { id: 4, href: "cltv", name: "Customer Lifetime Value (CLTV)" },
//           { id: 5, href: "cac", name: "Customer Acquisition Cost (CAC)" },
//           { id: 6, href: "cac-payback", name: "CAC Payback Period" },
//           { id: 7, href: "expansion-revenue", name: "Expansion Revenue" },
//           { id: 8, href: "nps", name: "Net Promoter Score (NPS)" },
//           {
//             id: 9,
//             href: "customer-retention",
//             name: "Customer Retention Rate",
//           },
//           { id: 10, href: "active-users", name: "Active Users/Customers" },
//           {
//             id: 11,
//             href: "customer-engagement",
//             name: "Customer Engagement Metrics",
//           },
//           { id: 12, href: "csat", name: "Customer Satisfaction (CSAT)" },
//           { id: 13, href: "product-adoption", name: "Product Adoption Rate" },
//           {
//             id: 14,
//             href: "customer-support",
//             name: "Customer Support Metrics",
//           },
//           { id: 15, href: "user-retention", name: "User Retention by Cohort" },
//           { id: 16, href: "gross-margin", name: "Gross Margin" },
//           { id: 17, href: "arpa", name: "Average Revenue per Account (ARPA)" },
//           { id: 18, href: "free-trial", name: "Free Trial Conversion Rate" },
//         ],
//       },
//       {
//         slug: "travelandtourism",
//         name: "Travel and Tourism",
//         items: [
//           { id: 1, href: "occupancy-rate", name: "Occupancy Rate" },
//           {
//             id: 2,
//             href: "average-daily-rate",
//             name: "Average Daily Rate (ADR)",
//           },
//           {
//             id: 3,
//             href: "revenue-per-available-room",
//             name: "Revenue per Available Room (RevPAR)",
//           },
//           { id: 4, href: "room-nights-sold", name: "Room Nights Sold" },
//           {
//             id: 5,
//             href: "average-length-of-stay",
//             name: "Average Length of Stay (ALOS)",
//           },
//           {
//             id: 6,
//             href: "customer-satisfaction-score",
//             name: "Customer Satisfaction Score (CSAT)",
//           },
//           {
//             id: 7,
//             href: "net-promoter-score",
//             name: "Net Promoter Score (NPS)",
//           },
//           {
//             id: 8,
//             href: "revenue-by-source-market",
//             name: "Revenue by Source Market",
//           },
//           {
//             id: 9,
//             href: "average-spend-per-visitor",
//             name: "Average Spend per Visitor",
//           },
//           { id: 10, href: "visitor-arrivals", name: "Visitor Arrivals" },
//           {
//             id: 11,
//             href: "visitor-demographics",
//             name: "Visitor Demographics",
//           },
//           {
//             id: 12,
//             href: "attraction-or-destination-attendance",
//             name: "Attraction or Destination Attendance",
//           },
//           {
//             id: 13,
//             href: "customer-loyalty",
//             name: "Customer Loyalty and Repeat Visitation",
//           },
//           { id: 14, href: "tourism-revenue", name: "Tourism Revenue" },
//           {
//             id: 15,
//             href: "booking-conversion-rate",
//             name: "Booking Conversion Rate",
//           },
//           { id: 16, href: "tourism-expenditure", name: "Tourism Expenditure" },
//           { id: 17, href: "tourism-employment", name: "Tourism Employment" },
//           {
//             id: 18,
//             href: "social-media-engagement",
//             name: "Social Media Engagement",
//           },
//           {
//             id: 19,
//             href: "tourism-infrastructure",
//             name: "Tourism Infrastructure and Development",
//           },
//         ],
//       },
//       {
//         slug: "hospitality",
//         name: "Hospitality",
//         items: [
//           { id: 1, href: "occupancy-rate", name: "Occupancy Rate" },
//           {
//             id: 2,
//             href: "average-daily-rate",
//             name: "Average Daily Rate (ADR)",
//           },
//           {
//             id: 3,
//             href: "revenue-per-available-room",
//             name: "Revenue per Available Room (RevPAR)",
//           },
//           { id: 4, href: "average-check-size", name: "Average Check Size" },
//           { id: 5, href: "table-turnover-rate", name: "Table Turnover Rate" },
//           { id: 6, href: "room-revenue", name: "Room Revenue" },
//           {
//             id: 7,
//             href: "food-and-beverage-revenue",
//             name: "Food and Beverage Revenue",
//           },
//           {
//             id: 8,
//             href: "customer-satisfaction-score",
//             name: "Customer Satisfaction Score (CSAT)",
//           },
//           {
//             id: 9,
//             href: "net-promoter-score",
//             name: "Net Promoter Score (NPS)",
//           },
//           {
//             id: 10,
//             href: "revenue-by-department",
//             name: "Revenue by Department",
//           },
//           {
//             id: 11,
//             href: "labor-cost-percentage",
//             name: "Labor Cost Percentage",
//           },
//           {
//             id: 12,
//             href: "customer-retention-rate",
//             name: "Customer Retention Rate",
//           },
//           {
//             id: 13,
//             href: "average-length-of-stay",
//             name: "Average Length of Stay (ALOS)",
//           },
//           {
//             id: 14,
//             href: "return-on-investment",
//             name: "Return on Investment (ROI)",
//           },
//           {
//             id: 15,
//             href: "maintenance-and-housekeeping-efficiency",
//             name: "Maintenance and Housekeeping Efficiency",
//           },
//           {
//             id: 16,
//             href: "cost-of-goods-sold",
//             name: "Cost of Goods Sold (COGS)",
//           },
//           {
//             id: 17,
//             href: "employee-turnover-rate",
//             name: "Employee Turnover Rate",
//           },
//           {
//             id: 18,
//             href: "event-and-banquet-sales",
//             name: "Event and Banquet Sales",
//           },
//           {
//             id: 19,
//             href: "online-reputation-score",
//             name: "Online Reputation Score",
//           },
//           {
//             id: 20,
//             href: "sustainability-metrics",
//             name: "Sustainability Metrics",
//           },
//         ],
//       },
//       {
//         slug: "bpo",
//         name: "BPO",
//         items: [
//           {
//             id: 1,
//             href: "service-level-agreement",
//             name: "Service Level Agreement (SLA)",
//           },
//           {
//             id: 2,
//             href: "average-handling-time",
//             name: "Average Handling Time (AHT)",
//           },
//           {
//             id: 3,
//             href: "first-call-resolution",
//             name: "First Call Resolution (FCR) Rate",
//           },
//           {
//             id: 4,
//             href: "customer-satisfaction-score",
//             name: "Customer Satisfaction Score (CSAT)",
//           },
//           {
//             id: 5,
//             href: "net-promoter-score",
//             name: "Net Promoter Score (NPS)",
//           },
//           { id: 6, href: "quality-assurance", name: "Quality Assurance (QA)" },
//           {
//             id: 7,
//             href: "agent-utilization-rate",
//             name: "Agent Utilization Rate",
//           },
//           { id: 8, href: "absenteeism-rate", name: "Absenteeism Rate" },
//           {
//             id: 9,
//             href: "adherence-to-schedule",
//             name: "Adherence to Schedule",
//           },
//           {
//             id: 10,
//             href: "employee-satisfaction",
//             name: "Employee Satisfaction (ESAT)",
//           },
//           {
//             id: 11,
//             href: "training-effectiveness",
//             name: "Training Effectiveness",
//           },
//           {
//             id: 12,
//             href: "revenue-per-fte",
//             name: "Revenue per Full-Time Equivalent (FTE)",
//           },
//           { id: 13, href: "cost-per-contact", name: "Cost per Contact" },
//           {
//             id: 14,
//             href: "customer-retention-rate",
//             name: "Customer Retention Rate",
//           },
//           { id: 15, href: "error-rate", name: "Error Rate" },
//           {
//             id: 16,
//             href: "service-level-achievement",
//             name: "Service Level Achievement",
//           },
//           {
//             id: 17,
//             href: "average-speed-of-answer",
//             name: "Average Speed of Answer (ASA)",
//           },
//           {
//             id: 18,
//             href: "customer-effort-score",
//             name: "Customer Effort Score (CES)",
//           },
//           {
//             id: 19,
//             href: "customer-complaint-resolution-time",
//             name: "Customer Complaint Resolution Time",
//           },
//           {
//             id: 20,
//             href: "process-improvement-initiatives",
//             name: "Process Improvement Initiatives",
//           },
//         ],
//       },
//       {
//         slug: "kpo",
//         name: "KPO",
//         items: [
//           { id: 1, href: "project-overview", name: "Project Overview" },
//           { id: 2, href: "resource-allocation", name: "Resource Allocation" },
//           {
//             id: 3,
//             href: "task-progress",
//             name: "Task Progress and Completion",
//           },
//           {
//             id: 4,
//             href: "quality-assurance",
//             name: "Quality Assurance (QA) Metrics",
//           },
//           {
//             id: 5,
//             href: "client-satisfaction",
//             name: "Client Satisfaction Score (CSAT)",
//           },
//           { id: 6, href: "knowledge-management", name: "Knowledge Management" },
//           { id: 7, href: "data-analysis", name: "Data Analysis and Insights" },
//           { id: 8, href: "time-tracking", name: "Time Tracking and Billing" },
//           {
//             id: 9,
//             href: "client-relationship",
//             name: "Client Relationship Management (CRM)",
//           },
//           { id: 10, href: "risk-management", name: "Risk Management" },
//           {
//             id: 11,
//             href: "financial-performance",
//             name: "Financial Performance",
//           },
//           {
//             id: 12,
//             href: "team-performance",
//             name: "Team Performance and Productivity",
//           },
//           {
//             id: 13,
//             href: "knowledge-domain",
//             name: "Knowledge Domain Expertise",
//           },
//           {
//             id: 14,
//             href: "compliance-regulatory",
//             name: "Compliance and Regulatory Reporting",
//           },
//           {
//             id: 15,
//             href: "executive-summary",
//             name: "Executive Summary and Insights",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     label: "Services",
//     items: [
//       {
//         slug: "accounting",
//         name: "Accounting",
//       },
//       {
//         slug: "bookkeeping",
//         name: "BookKeeping",
//       },
//       {
//         slug: "payroll",
//         name: "Payroll",
//       },
//       {
//         slug: "taxplanning",
//         name: "Tax Planning",
//       },
//       {
//         slug: "financialreporting",
//         name: "Financial Reporting",
//       },
//       {
//         slug: "audit",
//         name: "Audit",
//       },
//       {
//         slug: "duediligence",
//         name: "Due Diligence",
//       },
//       {
//         slug: "compliances",
//         name: "Compliances",
//       },
//     ],
//   },
//   {
//     label: "App Pages",
//     items: [
//       {
//         name: "Account",
//         items: [
//           { slug: "profile", name: "Profile" },
//           { slug: "billing", name: "Billing" },
//           { slug: "security", name: "Security" },
//           { slug: "notification", name: "Notifications" },
//         ],
//       },
//       {
//         slug: "pricing ",
//         name: "Pricing",
//       },
//       {
//         slug: "invoice",
//         name: "Invoice",
//       },
//     ],
//   },
//   {
//     label: "Customisation",
//     items: [
//       {
//         slug: "reports",
//         name: "Reports",
//       },
//       {
//         slug: "automation",
//         name: "Automation",
//       },
//     ],
//   },
//   {
//     label: "Accounting",
//     items: [
//       {
//         slug: "entryposting",
//         name: "Entry Posting",
//       },
//       {
//         slug: "reports",
//         name: "Reports",
//       },
//       {
//         slug: "bankstatement",
//         name: "Bank Statement",
//       },
//       {
//         slug: "revenueaccounting",
//         name: "Revenue Accounting",
//       },
//       {
//         slug: "expenseaccounting",
//         name: "Revenue Accounting",
//       },
//     ],
//   },
//   {
//     slug: "uploads",
//     label: "Uploads",
//   },
// ];


//Bank statement data
export const bankdata = [
  {"date":"2024-05-18","vendor":"Gigabox","description":"Reduced coherent time-frame","account":"Savings","amount":42.85,"in_out":"debit"},
  {"date":"2024-05-17","vendor":"Gigabox","description":"Reduced coherent time-frame","account":"Savings","amount":42.85,"in_out":"credit"},
  {"date":"2024-05-04","vendor":"Gigabox","description":"Reduced coherent time-frame","account":"Savings","amount":42.85,"in_out":"debit"},
  {"date":"2024-05-01","vendor":"Abatz","description":"Balanced radical model","account":"Credit Card","amount":183.3,"in_out":"credit"},
  {"date":"2024-05-09","vendor":"Dynabox","description":"Extended leading edge parallelism","account":"Savings","amount":92.49,"in_out":"debit"},
  {"date":"2024-05-07","vendor":"Voomm","description":"Reactive grid-enabled encoding","account":"Credit Card","amount":40.63,"in_out":"credit"},
  {"date":"2024-05-02","vendor":"Livetube","description":"Intuitive global attitude","account":"Checking","amount":133.89,"in_out":"debit"},
  {"date":"2024-05-05","vendor":"Jaloo","description":"Exclusive high-level neural-net","account":"Savings","amount":109.53,"in_out":"debit"},
  {"date":"2024-05-01","vendor":"Yotz","description":"Reactive solution-oriented strategy","account":"Credit Card","amount":159.16,"in_out":"credit"},
  {"date":"2024-05-09","vendor":"Oyoloo","description":"Quality-focused demand-driven array","account":"Checking","amount":19.27,"in_out":"credit"},
  {"date":"2024-05-06","vendor":"Blogtag","description":"User-friendly composite intranet","account":"Credit Card","amount":150.73,"in_out":"debit"},
  {"date":"2024-05-04","vendor":"JumpXS","description":"Persistent eco-centric process improvement","account":"Checking","amount":140.14,"in_out":"debit"},
  {"date":"2024-05-03","vendor":"Trudeo","description":"Centralized bi-directional definition","account":"Checking","amount":68.55,"in_out":"debit"},
  {"date":"2024-05-05","vendor":"Livefish","description":"Robust needs-based Graphical User Interface","account":"Checking","amount":97.21,"in_out":"credit"},
  {"date":"2024-05-01","vendor":"Topicblab","description":"Reactive tertiary functionalities","account":"Savings","amount":191.8,"in_out":"debit"},
  {"date":"2024-05-04","vendor":"Yodoo","description":"Ameliorated systematic hub","account":"Checking","amount":125.6,"in_out":"debit"},
  {"date":"2024-05-02","vendor":"Oyoloo","description":"Up-sized high-level methodology","account":"Credit Card","amount":133.47,"in_out":"debit"},
  {"date":"2024-05-06","vendor":"Avamba","description":"Intuitive reciprocal software","account":"Savings","amount":26.27,"in_out":"credit"},
  {"date":"2024-05-03","vendor":"Demivee","description":"Diverse encompassing collaboration","account":"Savings","amount":57.12,"in_out":"debit"},
  {"date":"2024-05-05","vendor":"Bubblemix","description":"Fundamental modular alliance","account":"Checking","amount":94.85,"in_out":"debit"},
  {"date":"2024-05-05","vendor":"Cogibox","description":"Total maximized emulation","account":"Credit Card","amount":7.83,"in_out":"debit"},
  {"date":"2024-05-07","vendor":"Divanoodle","description":"Exclusive optimizing neural-net","account":"Checking","amount":150.82,"in_out":"debit"},
  {"date":"2024-05-08","vendor":"Edgeify","description":"Sharable dedicated groupware","account":"Credit Card","amount":29.47,"in_out":"debit"},
  {"date":"2024-05-02","vendor":"Flashspan","description":"Devolved multi-state product","account":"Credit Card","amount":32.31,"in_out":"credit"},
  {"date":"2024-05-07","vendor":"Avaveo","description":"Organic cohesive analyzer","account":"Credit Card","amount":171.27,"in_out":"debit"},
  {"date":"2024-05-07","vendor":"Yadel","description":"Multi-layered real-time challenge","account":"Savings","amount":37.91,"in_out":"debit"},
  {"date":"2024-05-09","vendor":"Leenti","description":"Open-source directional project","account":"Checking","amount":60.66,"in_out":"debit"},
  {"date":"2024-05-01","vendor":"Myworks","description":"Optional radical structure","account":"Credit Card","amount":150.43,"in_out":"credit"},
  {"date":"2024-05-05","vendor":"Quimm","description":"Decentralized analyzing moratorium","account":"Checking","amount":81.87,"in_out":"debit"},
  {"date":"2024-05-09","vendor":"Skimia","description":"Horizontal bandwidth-monitored interface","account":"Checking","amount":153.84,"in_out":"credit"},
  {"date":"2024-05-07","vendor":"Photobug","description":"Phased real-time benchmark","account":"Savings","amount":161.9,"in_out":"debit"},
  {"date":"2024-05-09","vendor":"Browsebug","description":"Versatile contextually-based hardware","account":"Savings","amount":15.86,"in_out":"credit"},
  {"date":"2024-05-01","vendor":"Katz","description":"Quality-focused methodical success","account":"Checking","amount":48.15,"in_out":"credit"},
  {"date":"2024-05-05","vendor":"Quimba","description":"Synchronised foreground functionalities","account":"Savings","amount":154.56,"in_out":"debit"},
  {"date":"2024-05-09","vendor":"Npath","description":"Pre-emptive 5th generation throughput","account":"Savings","amount":96.94,"in_out":"debit"},
  {"date":"2024-05-07","vendor":"DabZ","description":"Realigned client-server knowledge user","account":"Checking","amount":46.85,"in_out":"debit"},
  {"date":"2024-05-08","vendor":"Eare","description":"Multi-channelled stable process improvement","account":"Savings","amount":93.34,"in_out":"debit"},
  {"date":"2024-05-08","vendor":"Skiptube","description":"Switchable user-facing emulation","account":"Checking","amount":136.9,"in_out":"debit"},
  {"date":"2024-05-01","vendor":"Edgewire","description":"Devolved object-oriented migration","account":"Checking","amount":50.22,"in_out":"debit"},
  {"date":"2024-05-03","vendor":"Divape","description":"Cross-group context-sensitive contingency","account":"Credit Card","amount":36.58,"in_out":"debit"},
  {"date":"2024-05-08","vendor":"Oba","description":"Extended high-level capability","account":"Checking","amount":129.95,"in_out":"debit"},
  {"date":"2024-05-07","vendor":"Topicstorm","description":"Organic context-sensitive access","account":"Credit Card","amount":188.28,"in_out":"debit"},
  {"date":"2024-05-01","vendor":"Oodoo","description":"Sharable next generation superstructure","account":"Savings","amount":71.65,"in_out":"debit"},
  {"date":"2024-05-05","vendor":"Eazzy","description":"Profit-focused optimizing portal","account":"Savings","amount":13.55,"in_out":"debit"},
  {"date":"2024-05-07","vendor":"Browsedrive","description":"Persistent empowering archive","account":"Credit Card","amount":164.79,"in_out":"debit"},
  {"date":"2024-05-07","vendor":"Wikivu","description":"Innovative non-volatile interface","account":"Savings","amount":38.56,"in_out":"debit"},
  {"date":"2024-05-07","vendor":"Yambee","description":"Stand-alone web-enabled software","account":"Credit Card","amount":107.11,"in_out":"debit"},
  {"date":"2024-05-02","vendor":"Flipbug","description":"Organized tertiary framework","account":"Savings","amount":132.0,"in_out":"debit"},
  {"date":"2024-05-03","vendor":"Devpulse","description":"Adaptive executive function","account":"Checking","amount":50.37,"in_out":"debit"},
  {"date":"2024-05-08","vendor":"Photolist","description":"Profit-focused zero tolerance initiative","account":"Savings","amount":129.52,"in_out":"debit"},
  {"date":"2024-05-06","vendor":"Photobug","description":"Programmable hybrid extranet","account":"Credit Card","amount":101.78,"in_out":"debit"},
  {"date":"2024-05-05","vendor":"Dabjam","description":"Centralized eco-centric time-frame","account":"Savings","amount":196.93,"in_out":"debit"},
  {"date":"2024-04-08","vendor":"Photolist","description":"Profit-focused zero tolerance initiative","account":"Savings","amount":129.52,"in_out":"debit"},
  {"date":"2024-04-06","vendor":"Photobug","description":"Programmable hybrid extranet","account":"Credit Card","amount":101.78,"in_out":"debit"},
  {"date":"2024-04-05","vendor":"Dabjam","description":"Centralized eco-centric time-frame","account":"Savings","amount":196.93,"in_out":"debit"},
  {"date":"2024-05-10","vendor":"Employer","description":"Monthly Salary","account":"Checking","amount":2500.00,"in_out":"credit"},
  {"date":"2024-05-11","vendor":"Freelance Client","description":"Payment for project","account":"Savings","amount":500.00,"in_out":"credit"},
  {"date":"2024-05-12","vendor":"Tax Refund","description":"IRS Tax Refund","account":"Checking","amount":300.00,"in_out":"credit"},
  {"date":"2024-05-13","vendor":"Investment","description":"Stock dividends","account":"Savings","amount":150.00,"in_out":"credit"},
  {"date":"2024-05-14","vendor":"Friend","description":"Reimbursement","account":"Checking","amount":100.00,"in_out":"credit"}
];

//Adjustment entry data
export const adjustmententry = [
  { "id":1,
    "value": "closingstock",
    "label": "Closing Stock",
    "heading":"Closing Stock",
    "headingto":"Trading",
  },
  {"id":2,
    "value": "outstandingexpenses",
    "label": "Outstanding Expenses",
    "heading":"Expenses",
    "headingto":"Outstanding Expenses",
  },
  {"id":3,
    "value": "prepaidexpenses",
    "label": "Prepaid Expenses",
    "heading":"Prepaid Expenses",
    "headingto":"Expenses",
  },
  { "id":4,
    "value": "accruedincome",
    "label": "Accrued Income",
    "heading":"Accrued Income",
    "headingto":"Income",
  },
  { "id":5,
    "value": "unearnedincome",
    "label": "Unearned Income",
    "heading":"Income",
    "headingto":"Unearned Income",
  },
  { "id":6,
    "value": "interestoncapital",
    "label": "Interest on Capital",
    "heading":"Interest on Capital",
    "headingto":"Capital",
  },
  {"id":7,
    "value": "interestondrawings",
    "label": "Interest on Drawings",
    "heading":"Drawings",
    "headingto":"Interest on Drawings",
  },
  {"id":8,
    "value": "interestondeposits",
    "label": "Interest on Deposits",
    "heading":"Bank Deposits",
    "headingto":"Interest on Deposits",
  },
  {"id":9,
    "value": "interestonloan",
    "label": "Interest on Loan",
    "heading":"Interest on Loan",
    "headingto":"Outstanding Interest",
  },
  { "id":10,
    "value": "proprietorysalary",
    "label": "Proprietor’s Salary",
    "heading":"Proprietor’s Salary",
    "headingto":"Capital",
  },
  { "id":11,
    "value": "depriciation",
    "label": "Depreciation",
    "heading":"Depreciation",
    "headingto":"Fixed Assets",
  },
  { "id":12,
    "value": "appreciation",
    "label": "Appreciation",
    "heading":"Fixed Assets",
    "headingto":"Appreciation",
  },
  { "id":13,
    "value": "baddebts",
    "label": "Bad Debts",
    "heading":"Bad Debts",
    "headingto":"Debtors",
  },
  { "id":14,
    "value": "badanddoubtfuldebts",
    "label": "Provision for Bad & Doubtful Debts",
    "heading":"Profit & Loss",
    "headingto":"Provision for Bad & Doubtful Debts",
  },
  { "id":15,
    "value": "baddebtsrecovered",
    "label": "Bad Debts Recovered",
    "heading":"Cash",
    "headingto":"Bad Debts Recovered",
  },
  { "id":16,
    "value": "new",
    "label": "New",
    // "heading":"Cash",
    // "headingto":"Bad Debts Recovered",
  }
]
